// GENERATED by apps/platform/scripts/generate-articles-manifest.mjs — do not edit by hand.
// Producer: vera-website content/generated/articles-manifest.json. Re-run the script when the website's articles change.
/* eslint-disable */
import type { ArticlesManifest, ArticlesManifestProvenance } from './articleTypes'

export const ARTICLES_MANIFEST_PROVENANCE: ArticlesManifestProvenance = {
  "producer": "vera-website scripts/articles-manifest.mjs",
  "readFrom": "~/Code/vera-website-worktrees/website-17/content/generated/articles-manifest.json",
  "commit": "fea530f",
  "branch": "website-17",
  "uncommitted": true,
  "sha256": "62cc715b76083e0bedb2f767544f01c91b72ef60d916510b2c9dab8cad776fba",
  "articles": 8,
  "generatedOn": "2026-10-12"
}

export const ARTICLES_MANIFEST: ArticlesManifest = {
  "schemaVersion": 1,
  "sections": {
    "insights": {
      "path": "/insights",
      "status": "staged"
    },
    "learn": {
      "path": "/learn",
      "status": "staged"
    }
  },
  "articles": [
    {
      "section": "insights",
      "slug": "resale-royalties-for-brands",
      "path": "/insights/resale-royalties-for-brands",
      "kind": "article",
      "title": "Secondary Market Revenue: Can Brands Earn From Resale?",
      "description": "When a bag or a watch resells, the platform takes a cut and the brand usually takes nothing. Why there is no resale royalty for brands, what art and NFTs show, and how brands earn from resale anyway.",
      "cover": {
        "type": "image",
        "src": "/insights/covers/resale-royalties-for-brands.webp",
        "alt": "A black structured leather handbag with one arched top handle and a pointed envelope flap, standing on a small black plinth beside a lower empty plinth in softer light."
      },
      "wordCount": 1552,
      "readMinutes": 7,
      "publishedAt": "2026-10-06",
      "updatedAt": null,
      "sourceCount": 16,
      "status": "staged",
      "contentHash": "40f447f67447bf8d"
    },
    {
      "section": "insights",
      "slug": "digital-certificates-vs-nfts",
      "path": "/insights/digital-certificates-vs-nfts",
      "kind": "article",
      "title": "Digital Certificates vs NFTs: Why a Product Doesn't Need a Blockchain",
      "description": "Some digital product passports are built on blockchains. Vera's is not. What an NFT actually proves about a physical object, what a tag and certificate prove, and why that difference matters more than the ledger.",
      "cover": {
        "type": "image",
        "src": "/insights/covers/digital-certificates-vs-nfts.webp",
        "alt": "An empty glass cloche on a low black plinth beside a second plinth holding a matte black wristwatch."
      },
      "wordCount": 1287,
      "readMinutes": 6,
      "publishedAt": "2026-10-06",
      "updatedAt": null,
      "sourceCount": 5,
      "status": "staged",
      "contentHash": "92188a88dae8788d"
    },
    {
      "section": "insights",
      "slug": "what-if-your-designer-bag-could-tell-its-story",
      "path": "/insights/what-if-your-designer-bag-could-tell-its-story",
      "kind": "article",
      "title": "What If Your Designer Bag Could Tell You Its Story",
      "description": "A handbag outlives its receipt, its box and often its first owner. What changes when the bag itself carries its record, from the workshop to every person who owns it next.",
      "cover": {
        "type": "motif",
        "motif": "story"
      },
      "wordCount": 1018,
      "readMinutes": 5,
      "publishedAt": "2026-09-30",
      "updatedAt": null,
      "sourceCount": 4,
      "status": "staged",
      "contentHash": "fcaad38e9ac98dd9"
    },
    {
      "section": "insights",
      "slug": "fashion-meets-ai-unlocking-consumer-insights-with-connected-garments",
      "path": "/insights/fashion-meets-ai-unlocking-consumer-insights-with-connected-garments",
      "kind": "article",
      "title": "Fashion Meets AI: Unlocking Consumer Insights with Connected Garments",
      "description": "AI is only as good as the data behind it, and most of what happens to a garment once it leaves the store has never been recorded. What connected garments can tell a brand, and what they cannot.",
      "cover": {
        "type": "motif",
        "motif": "intelligence"
      },
      "wordCount": 817,
      "readMinutes": 4,
      "publishedAt": "2025-10-15",
      "updatedAt": "2026-09-30",
      "sourceCount": 3,
      "status": "staged",
      "contentHash": "15d4030795bd4a5d"
    },
    {
      "section": "insights",
      "slug": "verifying-memorabilia-in-the-age-of-digital-fakes",
      "path": "/insights/verifying-memorabilia-in-the-age-of-digital-fakes",
      "kind": "article",
      "title": "Verifying Memorabilia in the Age of Digital Fakes",
      "description": "Forgers have better tools than ever, and a paper certificate is often easier to copy than the item it vouches for. How memorabilia authentication is changing, and why the record should travel with the object.",
      "cover": {
        "type": "motif",
        "motif": "provenance"
      },
      "wordCount": 841,
      "readMinutes": 4,
      "publishedAt": "2025-10-03",
      "updatedAt": "2026-09-30",
      "sourceCount": 2,
      "status": "staged",
      "contentHash": "6489ec9749a5f877"
    },
    {
      "section": "insights",
      "slug": "recommerce-risks-navigating-the-challenges-of-the-secondhand-market",
      "path": "/insights/recommerce-risks-navigating-the-challenges-of-the-secondhand-market",
      "kind": "article",
      "title": "Recommerce Risks: Navigating the Challenges of the Secondhand Market",
      "description": "Resale is growing fast, and so are its problems. The risks every recommerce business has to manage, from authenticity and grading to logistics, regulation, margins and trust.",
      "cover": {
        "type": "motif",
        "motif": "circular"
      },
      "wordCount": 780,
      "readMinutes": 4,
      "publishedAt": "2025-09-21",
      "updatedAt": "2026-09-30",
      "sourceCount": 3,
      "status": "staged",
      "contentHash": "bc81a7e764d43b51"
    },
    {
      "section": "insights",
      "slug": "the-eus-ecodesign-regulation-implications-for-luxury-brands",
      "path": "/insights/the-eus-ecodesign-regulation-implications-for-luxury-brands",
      "kind": "article",
      "title": "The EU's Ecodesign Regulation: Implications for Luxury Brands",
      "description": "Europe's Ecodesign for Sustainable Products Regulation is in force, but its rules reach products one group at a time. What it asks of luxury brands, and when.",
      "cover": {
        "type": "motif",
        "motif": "regulation"
      },
      "wordCount": 739,
      "readMinutes": 4,
      "publishedAt": "2025-09-10",
      "updatedAt": "2026-09-30",
      "sourceCount": 6,
      "status": "staged",
      "contentHash": "31959a8370dc8d2f"
    },
    {
      "section": "learn",
      "slug": "product-identity",
      "path": "/learn/product-identity",
      "kind": "explainer",
      "title": "What is product identity? (for physical products)",
      "description": "Product identity for physical products: a tag, a certificate and one record per item. How digital product identity supports authentication and the DPP.",
      "cover": {
        "type": "none"
      },
      "wordCount": 1420,
      "readMinutes": null,
      "publishedAt": "2026-10-12",
      "updatedAt": null,
      "sourceCount": 4,
      "status": "staged",
      "contentHash": "5f53ad9e8f043bf2"
    }
  ]
}
